module.exports = __webpack_public_path__ + "static/img/env02.9dde534.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/technology/images/env02.png
// module id = 99
// module chunks = 4